import { ListItemButton } from '@mui/material';
import { queueAnnouncement } from '@/Infrastructure/Components/Announcements/AnnouncementSlice';
import { getApiErrorMessage } from '@api/getApiError';
import { usePutLegsMutation } from '@api/Trinium/Endpoints/Leg';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import { useAppDispatch } from '@reduxStore';

import styles from './HubList.module.css';

/**
 * Individual Hub list items - Hub name and code
 */
export default function HubListItem(props: { terminalNumber: string; legIds: number[]; code: string; name: string; onClose: () => void }) {
	const { number: terminalNumber } = useCurrentTerminal();
	const appDispatch = useAppDispatch();
	const [putLegs] = usePutLegsMutation();

	const handleBtnClick = () => {
		void putLegs({
			terminalNumber,
			actionType: {
				action: 'hubContainer',
				data: {
					hubId: props.code,
					legIds: props.legIds
				}
			}
		})
			.unwrap()
			.catch((error: unknown) => {
				const errorMessage = getApiErrorMessage(error);
				appDispatch(
					queueAnnouncement({
						title: errorMessage,
						severity: 'error',
						clearable: true
					})
				);
			});
		props.onClose();
	};

	return (
		<ListItemButton onClick={handleBtnClick}>
			<div className={styles['hub-name-item']}>{props.name}</div>
			<div className={styles['hub-code-item']}>{props.code}</div>
		</ListItemButton>
	);
}
